import React from 'react';
import css from './NotificationDropdown.module.css';
import { IconSpinner } from '..';
import { filterNotificationTypes } from '../../util/circleHelper';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';

const NotificationSettings = props => {
  const {
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onUpdateNotificationPreference,
  } = props;
  const { notification_preferences = [] } = notificaitonPreferenceData ?? {};

  const handleOnNotificationItemClick = ({ type, enabled }) => {
    onUpdateNotificationPreference({ type, enabled: !enabled });
  };
  
  return (
    <div className={css.dropdownScroll}>
      {requestNotificationPreferenceInProgress && <div className={css.spinnerIcon}><IconSpinner type={true} /></div>}
      <ul>
        {notification_preferences?.filter(item => !filterNotificationTypes.includes(item.type))?.map(item => (
          <li className={css.checkedStatus} key={item.type} onClick={() => handleOnNotificationItemClick(item)}>
            {item.name} {item.enabled ? <ProfileIconCard type='checked_notification'/> : <ProfileIconCard type='unchecked_notification'/>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotificationSettings;
